import React, { useContext } from 'react';
import { useHistory } from "react-router-dom";
import Avatar from '@material-ui/core/Avatar';
import Snackbar from '@material-ui/core/Snackbar';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Box from '@material-ui/core/Box';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import FolderOutlinedIcon from '@material-ui/icons/FolderOutlined';
import Typography from '@material-ui/core/Typography';
import ClearIcon from '@material-ui/icons/Clear';
import Divider from '@material-ui/core/Divider';
import { ProgressBar } from "react-step-progress-bar";
import IconButton from '@material-ui/core/IconButton';

import HomeContext from '../../../context/home-context';

import { removeLearningContentFromSession, setLearningContentSession, setLearningContentLevel } from '../../../utils/helpers/others/SessionHelper'

const SnackbarMenu = () => {
    const { homeContext, handleClose } = useContext(HomeContext);
    const history = useHistory();

    function renderIcon(param) {
        switch (param) {
            case 2:
                return <Avatar variant="square" src="./assets/images/components/shared/traits/learning/UI_CityIcon_Learning-min.png" className="snackbarmenu__avatar" />;
            case 1:
                return <Avatar src="./assets/images/components/shared/traits/mindset/UI_CityIcon_Mindset-min.png" className="snackbarmenu__avatar" />;
            case 4:
                return <Avatar src="./assets/images/components/shared/traits/wellbeing/UI_CityIcon_Wellbeing-min.png" className="snackbarmenu__avatar" />;
            case 3:
                return <Avatar src="./assets/images/components/shared/traits/resilience/UI_CityIcon_Resilience-min.png" className="snackbarmenu__avatar" />;
            default:
                return <Avatar className="snackbarmenu__avatar"><HelpOutlineIcon /></Avatar>
        }
    };

    const browseLearningContent = (traitGroupId, traitGroupName) => {
        const learningContent = {
            learningContentCategoryId: traitGroupId,
            learningContentCategoryName: traitGroupName,
            levelText: Math.floor(homeContext.snackbarMenu.levelpercent / 20),
            learningContentId: null
        };
        removeLearningContentFromSession();
        setLearningContentSession(JSON.stringify(learningContent));
        setLearningContentLevel(learningContent.levelText);
        history.push("/LearningContents");
    }

    return (
        <div className="snackbarmenu">
            <Snackbar open={homeContext.snackbarMenu.open} anchorOrigin={{ vertical: 'bottom', horizontal: 'right', }} TransitionComponent={homeContext.snackbarMenu.transition}>
                <Box>
                    <Card className="snackbarmenu__card">
                        <CardHeader
                            avatar=
                            {renderIcon(homeContext.snackbarMenu.traitid)}
                            action={
                                <IconButton onClick={handleClose}>
                                    <ClearIcon />
                                </IconButton>
                            }
                            title={<Typography className="snackbarmenu__heading">{homeContext.snackbarMenu.title}</Typography>}
                            subheader={<Box className="snackbarmenu__progress">
                                <ProgressBar
                                    percent={homeContext.snackbarMenu.levelpercent}
                                    filledBackground="linear-gradient(to right, #fefb72, #f0bb31)"
                                />
                            </Box>}
                        />
                        <Divider />

                        <CardHeader
                            avatar={
                                <IconButton onClick={() => browseLearningContent(homeContext.snackbarMenu.traitid, homeContext.snackbarMenu.title)}>
                                    <FolderOutlinedIcon className="snackbarmenu__foldericon" />
                                </IconButton>
                            }
                            action={
                                <div className="level">
                                    <Typography className="level__tag">LEVEL {homeContext.snackbarMenu.leveltext}</Typography>
                                </div>
                            }
                            title={
                                <Typography className="snackbarmenu__lcHeading">
                                    Learning Content
                                </Typography>
                            }
                            subheader={<Typography className="snackbarmenu__lcSubHeading">Recommended: {homeContext.snackbarMenu.recommendation}</Typography>}
                        ></CardHeader>
                    </Card>
                </Box>
            </Snackbar>
        </div>
    );
};

export { SnackbarMenu as default }